<template>
	<div class="wrapper-frete">
		<div>
			<div class="flex items-center justify-between">
				<h2 class="flex head-bold" style="align-items: center; gap: 8px">
					<svg class="icon-frete" width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M19 4H16V0H2C0.9 0 0 0.9 0 2V13H2C2 14.66 3.34 16 5 16C6.66 16 8 14.66 8 13H14C14 14.66 15.34 16 17 16C18.66 16 20 14.66 20 13H22V8L19 4ZM5 14.5C4.17 14.5 3.5 13.83 3.5 13C3.5 12.17 4.17 11.5 5 11.5C5.83 11.5 6.5 12.17 6.5 13C6.5 13.83 5.83 14.5 5 14.5ZM18.5 5.5L20.46 8H16V5.5H18.5ZM17 14.5C16.17 14.5 15.5 13.83 15.5 13C15.5 12.17 16.17 11.5 17 11.5C17.83 11.5 18.5 12.17 18.5 13C18.5 13.83 17.83 14.5 17 14.5Z"
							fill="#001E50"
						/>
					</svg>
					Simule o frete
				</h2>
				<a v-if="fretes.length > 0 && !loading" class="head-regular trocar-cep" href.prevent="#" @click="changeCEP()">Trocar CEP</a>
			</div>
			<div class="head-regular color-grey-3c">Entrega em todo o Brasil</div>
		</div>
		<div>
			<div v-if="fretes.length === 0 && !loading" class="relative w-full flex">
				<label class="inputlabel__ds">CEP*</label>
				<the-mask class="input__ds w-full" placeholder="Insira o CEP para simulação" :mask="['#####-###']" maxlength="10" :masked="true" type="tel" :value="value" @change="onChange" @input="onInput" />
				<button style="max-width: 120px; margin-left: 8px; height: 49px" @click="onClick" class="btn__primary--outline">Simular</button>
			</div>

			<div class="frete__error head-regular" style="color: red; margin-top: 8px" v-if="error !== ''">
				{{ error }}
			</div>

			<div v-if="loading">
				<Loader></Loader>
			</div>

			<div class="frete__table" v-if="fretes.length > 0 && !loading">
				<div class="head-bold frete__tableheader">Frete simulado para o CEP {{ value }}</div>
				<div class="frete__rowwrapper">
					<div v-for="item in fretes" :key="item.id">
						<div class="frete__row">
							<div class="vw-head-light">{{ item.entrega_metodo_nome }} - {{ item.entrega_estimada_dias }} {{ daysText(item.entrega_estimada_dias) }}</div>
							<div class="vw-head-light">{{ item.entrega_custo_final | formatarMoeda }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DefaultButton from "@/components/Common/DefaultButton"
import { TheMask } from "vue-the-mask"
import { getDaysText } from "@/utils/product"
import Loader from "@/components/Common/Loader.vue"
export default {
	components: {
		TheMask,
		Loader,
		DefaultButton,
	},
	props: {
		value: {
			type: [String, Number],
			required: false,
			default: null,
		},
		fretes: {
			type: Array,
			required: false,
			default: [],
		},
		loading: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: "",
		},
	},
	data() {
		return {}
	},
	methods: {
		changeCEP() {
			this.$emit("changeCEP")
		},
		daysText(days) {
			return getDaysText(days)
		},
		onInput(e) {
			this.$emit("input", e)
		},
		onChange(e) {
			this.$emit("change", e)
		},
		onClick() {
			this.$emit("click", this.value)
		},
	},
}
</script>

<style lang="scss" scoped>
.frete__error {
	font-size: 12px;
	line-height: 15px;
	@media (min-width: 1025px) {
		font-size: 16px;
		line-height: 19px;
	}
}
.frete {
	min-height: 49px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	input[type="text"] {
		border: 1px solid #96a3a8;
		height: 40px;
		padding: 8px;
		color: #565656;
		max-width: 113px;
	}
	&__head {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 16px;
		margin-bottom: 8px;
	}
	&__row {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		line-height: 17px;
		color: #3c484d;
		gap: 4px;
		@media (min-width: 768px) {
			font-size: 16px;
			line-height: 19px;
		}
	}
}
.frete__rowwrapper {
	display: flex;
	flex-direction: column;
	gap: 4px;
}
@media (max-width: 767px) {
	.frete {
		&__table {
			overflow-x: scroll;
			white-space: nowrap;
			width: 100%;
		}
		&__start {
			flex-wrap: wrap;
			gap: 16px;
		}
	}
}

.wrapper-frete {
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
	h2 {
		font-size: 16px;
		line-height: 19px;
		color: #3c484d;
	}
}
.input__ds {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 22px 16px 8px 16px;
	background: #f1f1f1;
	border: 1px solid #c2c2c2;
	border-radius: 4px 4px 0px 0px;
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	height: 49px;
	color: #000000;
	&.danger {
		border: 1px solid red;
		padding: 22px 16px 8px 16px;
	}
	&::placeholder {
		color: #c6cad1;
	}
}
.inputlabel__ds {
	position: absolute;
	top: 8px;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	color: #6f6f6f;
	left: 16px;
}
.trocar-cep {
	font-size: 12px;
	line-height: 15px;
	color: #6f6f6f;
	cursor: pointer;
	text-decoration: underline;
}
.frete__tableheader {
	font-size: 12px;
	line-height: 15px;
	color: #4e4f50;
	margin-bottom: 16px;
}
.icon-frete {
	path {
		fill: var(--icon-frete-color);
	}
}
</style>
